<script>
export default {
  props: {
    userData: {
      type: Object
    },
    pdfData: { type: String, default: '' },
    loading: { type: Boolean },
    loadingPdfDataZoom: {
      type: Boolean
    },
    submitting: { type: Boolean }
  },
  data() {
    return {

    }
  }
}
</script>
<template>
  <v-row justify="center">
    <v-col xl="8">
      <v-card>
        <DialogBaseColoredTitle>{{
            $t('component.testletter.header')}}</DialogBaseColoredTitle>
        <v-divider></v-divider>
        <DialogBaseText class="text-center">
          <v-row v-if="userData.filled" justify="center">
            <v-col cols="10" class="blockQuote">
              <p class="text-center">
                <b>{{ $t('component.testletter.userdata.filled.P1') }}</b></p>
              <p class="blockQuote">
                {{ $t('component.testletter.userdata.filled.p2') }}
                <v-icon
                  color="primary"
                  class="dashed"
                  @click="$emit('onShowForm')"
                >mdi-note-text-outline</v-icon>
                {{ $t('component.testletter.userdata.filled.p3') }}
              </p>
              <p class="blockQuote">
                {{ $t('component.testletter.userdata.filled.p4') }}
              </p>
              <p class="blockQuote">
                {{ $t('component.testletter.userdata.filled.p5') }}
                <v-btn
                  id="routeToRegister"
                  :to="{ name: 'register' }"
                  elevation="5"
                  class="tam-yellow"
                >{{$t('button.now.register')}}</v-btn>
              </p>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="auto">
              <v-progress-circular
                v-if="loading"
                color="primary"
                indeterminate />
              <v-hover v-else>
                <template #default="{ hover }">
                  <v-card>
                    <v-img :src="pdfData" class="dashed" width="602" />
                    <v-fade-transition>
                      <v-overlay v-if="hover" absolute>
                        <v-row>
                          <v-col>
                            <v-btn
                              class="tam-yellow"
                              @click="$emit('onShowForm')"
                            >{{$t('button.fullscreen')}}</v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn
                              v-if="true || userData.filled"
                              :loading="loadingPdfDataZoom"
                              dark
                              color="primary"
                              class="mt-2"
                              @click.prevent="$emit('onShowDocumentViewer')"
                            ><v-icon class="pr-2">mdi-selection-search</v-icon
                            >{{ $t('button.fullscreen') }}</v-btn>
                          </v-col>
                        </v-row>
                      </v-overlay>
                    </v-fade-transition>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
          </v-row>
        </DialogBaseText>
        <v-divider></v-divider>
        <DialogBaseActions>
          <v-row>
            <v-col><v-btn color="error">{{ $t('button.cancel') }}</v-btn></v-col>
            <v-col>
              <v-btn
                :disabled="!userData.filled"
                :loading="submitting"
                class="tam-yellow"
                @click="$emit('onCompleted')"
              >{{ $t('button.send.testletter') }}</v-btn>
            </v-col>
          </v-row>
        </DialogBaseActions>
      </v-card>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
.dashed {
  border: 2px dashed rgba(0, 0, 0, 0.8);
  cursor: pointer;
}
.blockQuote {
  hyphens: auto;
  text-align: justify;
}
</style>
